import store from "@/core/services";
import module, {
  BASE_URL,
  GET_ITEMS,
  MODULE_NAME,
} from "@/core/services/store/integrations.module";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes", isCompression: true });

export const integrationMixin = {
  data() {
    return {
      integrations: [],
    };
  },
  computed: {
    hasIyzicoIntegration() {
      if (!this.integrations || this.integrations.length === 0) {
        return false;
      }

      const iyzicoIntegration = this.integrations.find(
        (integration) => integration.key_name === "iyzico"
      );

      if (!iyzicoIntegration) {
        return false;
      }

      return iyzicoIntegration.activated_at;
    },
  },
  methods: {
    loadIntegrations() {
      const token = ls.get('token');

      if (!token) {
        return;
      }

      if (!(store && store.state && store.state[MODULE_NAME])) {
        store.registerModule(MODULE_NAME, module);
      }

      store
        .dispatch(MODULE_NAME + "/" + GET_ITEMS, {
          url: BASE_URL,
          filters: {
            by_user: true,
          },
        })
        .then((response) => {
          if (Array.isArray(response)) {
            this.integrations = [...response];
          } else {
            this.integrations = [];
          }
        })
        .catch(() => {
          this.integrations = [];
        });
    },
  },
  created() {
    const token = localStorage.getItem('access_token');
    if (!token) return;         
    this.loadIntegrations();
  },
};
